var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchbarClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#clip0_4053_17763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C6.67441 0.501588 5.40356 1.02888 4.46622 1.96622C3.52888 2.90356 3.00159 4.17441 3 5.5V23.5C3.00014 23.6819 3.04989 23.8603 3.14388 24.016C3.23788 24.1717 3.37256 24.2989 3.53344 24.3837C3.69431 24.4686 3.87529 24.508 4.05688 24.4976C4.23847 24.4873 4.4138 24.4276 4.564 24.325L6.67 22.886L8.776 24.325C8.94239 24.4389 9.13934 24.4999 9.341 24.4999C9.54266 24.4999 9.73961 24.4389 9.906 24.325L12.006 22.886L14.106 24.325C14.2725 24.4392 14.4696 24.5003 14.6715 24.5003C14.8734 24.5003 15.0705 24.4392 15.237 24.325L17.337 22.887L19.437 24.324C19.5871 24.4263 19.7623 24.4857 19.9436 24.496C20.125 24.5062 20.3057 24.4669 20.4664 24.3821C20.627 24.2974 20.7616 24.1706 20.8556 24.0151C20.9496 23.8597 20.9996 23.6816 21 23.5V5.5C20.9984 4.17441 20.4711 2.90356 19.5338 1.96622C18.5964 1.02888 17.3256 0.501588 16 0.5L8 0.5ZM14 14.5H8C7.73478 14.5 7.48043 14.3946 7.29289 14.2071C7.10536 14.0196 7 13.7652 7 13.5C7 13.2348 7.10536 12.9804 7.29289 12.7929C7.48043 12.6054 7.73478 12.5 8 12.5H14C14.2652 12.5 14.5196 12.6054 14.7071 12.7929C14.8946 12.9804 15 13.2348 15 13.5C15 13.7652 14.8946 14.0196 14.7071 14.2071C14.5196 14.3946 14.2652 14.5 14 14.5ZM17 9.5C17 9.76522 16.8946 10.0196 16.7071 10.2071C16.5196 10.3946 16.2652 10.5 16 10.5H8C7.73478 10.5 7.48043 10.3946 7.29289 10.2071C7.10536 10.0196 7 9.76522 7 9.5C7 9.23478 7.10536 8.98043 7.29289 8.79289C7.48043 8.60536 7.73478 8.5 8 8.5H16C16.2652 8.5 16.5196 8.60536 16.7071 8.79289C16.8946 8.98043 17 9.23478 17 9.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4053_17763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbarClose);
export default __webpack_public_path__ + "static/media/searchbar-close.801261ee24bba42ca24902aed995e0fc.svg";
export { ForwardRef as ReactComponent };